module.exports = __webpack_public_path__ + "img/BGMain4.12025e98.jpg";